<template>
    <CadastroPadrao :cabecalho="state.cabecalho" :linhas="state.linhas" :url="state.url" :titulo="state.titulo"
        :limparInput="limparInput" :objeto="state.objetoAuxiliar" :lstObrigatorios="state.lstObrigatorios"
        :lstObrigatoriosLabel="state.lstObrigatoriosLabel">
        <template v-slot:ficha>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Código
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.id" disabled>
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Descrição
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.descricao"
                        placeholder="Descrição">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Ativo
                </label>
                <div class="col inp">
                    <input type="checkbox" class="form-check-input" v-model="state.objetoAuxiliar.ativo">
                </div>
            </div>
            <div class="row p-2">
                <label for="" class="col lbl">
                    Código Setor
                </label>
                <div class="col inp">
                    <input type="text" class="form-control" v-model="state.objetoAuxiliar.codigoSetor">
                </div>
            </div>
        </template>
    </CadastroPadrao>
</template>

<script setup>
import CadastroPadrao from '@/components/CadastroPadrao.vue';
import store from '@/store/store';
import { reactive, onMounted, computed } from 'vue';

const state = reactive({
    cabecalho: ['Descrição', 'Código', 'Número do Setor', 'Ativo'],
    linhas: ['descricao', 'id', 'codigoSetor', 'ativo'],
    url: "Setor",
    titulo: "Cadastro de Setor",
    objetoAuxiliar: {
        ativo: Boolean()
    },
    lstObrigatorios: ['descricao', 'codigoSetor'],
    lstObrigatoriosLabel: ['Descrição', 'Código do Setor'],
});

async function limparInput(pObj) {
    if (pObj) {
        state.objetoAuxiliar = pObj;
    } else {
        state.objetoAuxiliar = {};
        let maiorId = 0;
        setor.value.forEach(s => {
            if (maiorId < s.id) {
                maiorId = s.id;
            }
        });
        state.objetoAuxiliar.id = maiorId + 1;
        state.objetoAuxiliar.ativo = true;
        state.objetoAuxiliar.codigoSetor = Number();
    }
}
const setor = computed(() => {
    return store.state.setores;
});
</script>

<style scoped>
.lbl {
    max-width: 35%;
    line-height: 35px;
}
</style>